import IconBase from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

/**
 * 
 * <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.99982 11.0076C8.90944 11.0076 8.82532 10.9932 8.74744 10.9643C8.66957 10.9354 8.59551 10.886 8.52526 10.8158L5.15457 7.44514C5.05082 7.34126 4.99769 7.2107 4.99519 7.05345C4.99282 6.89632 5.04594 6.76339 5.15457 6.65464C5.26332 6.54601 5.39507 6.4917 5.54982 6.4917C5.70457 6.4917 5.83632 6.54601 5.94507 6.65464L8.99982 9.70957L12.0546 6.65464C12.1584 6.55089 12.289 6.49776 12.4463 6.49526C12.6034 6.49289 12.7363 6.54601 12.8451 6.65464C12.9537 6.76339 13.008 6.89514 13.008 7.04989C13.008 7.20464 12.9537 7.33639 12.8451 7.44514L9.47438 10.8158C9.40413 10.886 9.33007 10.9354 9.25219 10.9643C9.17432 10.9932 9.09019 11.0076 8.99982 11.0076Z" fill="#4C5053"/>
</svg>

 */
const KeyboardArrowDownLine = ({ width = 18, height = 18, ...props }: IconProps) => {
  return (
    <IconBase
      width={width}
      height={height}
      viewBox="0 0 18 18"
      paths={[
        {
          d: 'M8.99982 11.0076C8.90944 11.0076 8.82532 10.9932 8.74744 10.9643C8.66957 10.9354 8.59551 10.886 8.52526 10.8158L5.15457 7.44514C5.05082 7.34126 4.99769 7.2107 4.99519 7.05345C4.99282 6.89632 5.04594 6.76339 5.15457 6.65464C5.26332 6.54601 5.39507 6.4917 5.54982 6.4917C5.70457 6.4917 5.83632 6.54601 5.94507 6.65464L8.99982 9.70957L12.0546 6.65464C12.1584 6.55089 12.289 6.49776 12.4463 6.49526C12.6034 6.49289 12.7363 6.54601 12.8451 6.65464C12.9537 6.76339 13.008 6.89514 13.008 7.04989C13.008 7.20464 12.9537 7.33639 12.8451 7.44514L9.47438 10.8158C9.40413 10.886 9.33007 10.9354 9.25219 10.9643C9.17432 10.9932 9.09019 11.0076 8.99982 11.0076Z',
          fill: props.fill || '#4C5053',
        },
      ]}
      {...props}
    />
  );
};

export default KeyboardArrowDownLine;
